import type { BondListDecision, BondSubmissionStatus } from "@/lib/brokerBonds";

// The words the Surety lists use for PMS's bond vocabularies (BRK-S174,
// BRK-S181), shared by the bond submissions list definition and the account
// tab's table (BRK-S253).

/** How a decision reads. Three words, and nothing behind them: the vocabulary
 *  is derived upstream from the broker-safe facts the order view already
 *  publishes, and there is no reason, score or tier to render (PMS-S461). */
export const DECISION_LABEL: Record<BondListDecision, string> = {
  approved: "Approved",
  referred: "Referred",
  pending: "Pending",
};

/** `?status=` values, as PMS's own vocabulary spells them.
 *
 *  `withdrawn` (BRK-S502, the v2 status) is the one way to see a withdrawn
 *  order: PMS EXCLUDES ended orders from the unfiltered list, so "All
 *  statuses" means every live order and a withdrawn one is reached by asking
 *  for it. The client does not filter anything itself; that default is the
 *  server's. */
export const BOND_STATUS_FILTER_OPTIONS: readonly {
  value: BondSubmissionStatus;
  label: string;
}[] = [
  { value: "draft", label: "Draft" },
  { value: "submitted", label: "Filed with Signal" },
  // PMS leaves these out of the unfiltered list, so this option is the only
  // way to them (BRK-S323, rule 21; `withdrawn` since BRK-S502).
  { value: "withdrawn", label: "Withdrawn" },
];

/** `?decision=` values (PMS-S461). */
export const BOND_DECISION_FILTER_OPTIONS: readonly {
  value: BondListDecision;
  label: string;
}[] = [
  { value: "approved", label: "Approved" },
  { value: "referred", label: "Referred" },
  { value: "pending", label: "Pending" },
];
